import { Spacer } from "@hackthenorth/north";
import { Button, Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { Modal } from "src/shared/components";

export type TBulkDeleteShift = {
  shiftId: number;
  name: string;
};

type Props = {
  open: boolean;
  shifts: TBulkDeleteShift[];
  deleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const NAME_PREVIEW = 8;

const BulkDeleteConfirmModal: React.FC<Props> = ({
  open,
  shifts,
  deleting,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  const count = shifts.length;
  const preview = shifts.slice(0, NAME_PREVIEW);
  const remaining = count - preview.length;

  return (
    <StyledModal isOpen={open} onClose={onCancel} width="480px" height="auto">
      <Text type="h3">
        Delete {count} shift{count === 1 ? "" : "s"}?
      </Text>
      <Spacer height={16} />
      <Text type="body1">
        This permanently removes the selected shift
        {count === 1 ? "" : "s"} and any volunteer signups on{" "}
        {count === 1 ? "it" : "them"}. You can&apos;t undo this.
      </Text>
      <Spacer height={16} />
      <NameList>
        {preview.map((shift) => (
          <li key={shift.shiftId}>{shift.name}</li>
        ))}
        {remaining > 0 && <More>+ {remaining} more</More>}
      </NameList>
      <Spacer height={24} />
      <Actions>
        <Button
          color="secondary"
          size="md"
          disabled={deleting}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          color="secondary-danger"
          size="md"
          disabled={deleting}
          onClick={onConfirm}
        >
          {deleting
            ? "Deleting..."
            : `Delete ${count} shift${count === 1 ? "" : "s"}`}
        </Button>
      </Actions>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-height: 90vh;
`;

const NameList = styled.ul`
  margin: 0;
  padding: 12px 16px 12px 32px;
  border-radius: 8px;
  background: ${({ theme }) => theme.globalConstants.color.backgroundGray};
  max-height: 220px;
  overflow-y: auto;
`;

const More = styled.li`
  list-style: none;
  margin-left: -16px;
  font-weight: 700;
  color: ${({ theme }) => theme.globalConstants.color.textSecondary};
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export default BulkDeleteConfirmModal;
